import axios from "axios";
import { ApiResponse, handleApiErrors } from "..";
import { DeleteImageParams, CreateImageParams, GalleryImage, GalleryImagesParams, LocationData, LocationDeviceAndGal, LocationDeviceAndGalParams, IEvent, HasEvent, Devices, MasterID, Device, UpdateActiveImg, DeleteEvent, CreateGalleryParams, GetDevice, PostUpdateDeviceParams, RemoveActiveParams, ISlideshow} from "./models";

export const baseUrl = () => {
    return `${process.env.REACT_APP_InfoModul_API}`;
}

export async function getLocationOverview(): Promise<ApiResponse<LocationData[]>> {
    return axios.get<LocationData[]>(
        `${baseUrl()}/masterList`
    ).then(res => { return { data: res.data, errorStatus: undefined, errorMessage: undefined } })
        .catch((e) => handleApiErrors<LocationData[]>(e));
}

export async function getDeviceList(params: MasterID): Promise<ApiResponse<Devices[]>> {
    return axios.get<Devices[]>(
        `${baseUrl()}/Devices/${params.masterId}`
    ).then(res => { return { data: res.data, errorStatus: undefined, errorMessage: undefined } })
        .catch((e) => handleApiErrors<Devices[]>(e));
}

export async function getLocationDeviceAndGal(params: LocationDeviceAndGalParams): Promise<ApiResponse<LocationDeviceAndGal>> {
    return axios.get<LocationDeviceAndGal>(
        `${baseUrl()}/masterDeviceAndGal/${params.locationId}`
    ).then(res => { return { data: res.data, errorStatus: undefined, errorMessage: undefined } })
        .catch((e) => handleApiErrors<LocationDeviceAndGal>(e));
}

export async function getGalleryImages(params: GalleryImagesParams): Promise<ApiResponse<GalleryImage[]>> {
    return axios.get<GalleryImage[]>(
        `${baseUrl()}/GetGalleryImages/${params.galleryId}`
    ).then(res => { return { data: res.data, errorStatus: undefined, errorMessage: undefined } })
        .catch((e) => handleApiErrors<GalleryImage[]>(e));
}

export async function getImageDevice(params: GalleryImage): Promise<ApiResponse<number[]>> {
    return axios.get<number[]>(
        `${baseUrl()}/GetImageDevice/${params.imgName}`
    ).then(res => { return { data: res.data, errorStatus: undefined, errorMessage: undefined } })
        .catch((e) => handleApiErrors<number[]>(e));
}

export async function postCreateImage(params: CreateImageParams): Promise<ApiResponse<any>> {
    return axios.post<any>(
        `${baseUrl()}/PostGalleryImage/${params.galleryId}/image`,
        params.form,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    ).then(res => { return { data: res.data, errorStatus: undefined, errorMessage: undefined } })
        .catch((e) => handleApiErrors<any>(e));
}

export async function setDefault(params: DeleteEvent): Promise<ApiResponse<any>> {
    return axios.post<any>(
        `${baseUrl()}/setDefault/${params.imageId}`,
    ).then(res => { return { data: res.data, errorStatus: undefined, errorMessage: undefined } })
        .catch((e) => handleApiErrors<any>(e));
}

export async function createGallery(params: CreateGalleryParams): Promise<ApiResponse<CreateGalleryParams>> {
    return axios.post<CreateGalleryParams>(
        `${baseUrl()}/NewGallery`,
        { ...params.body }
    ).then(res => { return { data: res.data, errorStatus: undefined, errorMessage: undefined } })
        .catch((e) => handleApiErrors<CreateGalleryParams>(e));
}

export async function deleteImage(params: DeleteImageParams): Promise<ApiResponse<any>> {
    return axios.delete<any>(
        `${baseUrl()}/GalleryImage/${params.imageId}/${params.imageName}`
    ).then(res => { return { data: res.data, errorStatus: undefined, errorMessage: undefined } })
        .catch((e) => handleApiErrors<any>(e));
}

export async function createEvent(params: IEvent): Promise<ApiResponse<any>> {
    return axios.post<any>(
        `${baseUrl()}/postEvent/${params.imgName}`,
        params.body,
        {
            headers: {
                'Content-Type': 'application/json'
            }
        }
    ).then(res => { return { data: res.data, errorStatus: undefined, errorMessage: undefined } })
        .catch((e) => handleApiErrors<any>(e));
}

export async function ActiveEvent(params: GalleryImagesParams): Promise<ApiResponse<HasEvent[]>> {
    return axios.get<HasEvent[]>(`${baseUrl()}/HasActiveEvent/${params.galleryId}`,)
        .then(res => { return { data: res.data, errorStatus: undefined, errorMessage: undefined } })
        .catch((e) => handleApiErrors<HasEvent[]>(e));
}

/* export async function UpdateDevices(params: Device): Promise<ApiResponse<Device>> {
    return axios.post<Device>(
        `${baseUrl()}/UpdateDevices`,
        { ...params.body }
    ).then(res => { return { data: res.data, errorStatus: undefined, errorMessage: undefined } })
        .catch((e) => handleApiErrors<Device>(e));
} */

export async function DeviceUpdateNow(params: PostUpdateDeviceParams): Promise<ApiResponse<PostUpdateDeviceParams>> {
    return axios.post<PostUpdateDeviceParams>(
        `${baseUrl()}/Device/update`,
        { ...params.body }
    ).then(res => { return { data: res.data, errorStatus: undefined, errorMessage: undefined } })
        .catch((e) => handleApiErrors<PostUpdateDeviceParams>(e));
}

export async function getSbsPortNum(params: MasterID): Promise<ApiResponse<any>> {
    return axios.get<any>(`${baseUrl()}/sbsPortnr/${params.masterId}`)
        .then(res => { return { data: res.data, errorStatus: undefined, errorMessage: undefined } })
        .catch((e) => handleApiErrors<any>(e));
}

export async function updateActiveImg(params: UpdateActiveImg): Promise<ApiResponse<any>> {
    return axios.post<any>(`${baseUrl()}/UpdateDeviceImages`,
        params.body,
        {
            headers: {
                'Content-Type': 'application/json'
            }
        }
    ).then(res => { return { data: res.data, errorStatus: undefined, errorMessage: undefined } })
        .catch((e) => handleApiErrors<any>(e));
}
export async function deleteEvent(params: DeleteEvent): Promise<ApiResponse<any>> {
    return axios.delete<any>(`${baseUrl()}/deleteEvent/${params.imageId}`)
        .then(res => { return { data: res.data, errorStatus: undefined, errorMessage: undefined } })
        .catch((e) => handleApiErrors<any>(e));
}

export async function getOutOfOrderImages(params: GetDevice): Promise<ApiResponse<any>> {
    return axios.get<any>(`${baseUrl()}/outoforder/${params.masterId}/${params.deviceId}`)
        .then(res => { return { data: res.data, errorStatus: undefined, errorMessage: undefined } })
        .catch((e) => handleApiErrors<any>(e));
}

export async function RemoveActive(params: RemoveActiveParams): Promise<ApiResponse<any>> {
    return axios.post<any>(`${baseUrl()}/removeActive/${params.imgId}`,
        params.body,
        {
            headers: { 'Content-Type': 'application/json' },
        }
    ).then(res => { return { data: res.data, errorStatus: undefined, errorMessage: undefined } })
        .catch((e) => handleApiErrors<any>(e));
}

export async function createSlideshow(params: ISlideshow): Promise<ApiResponse<any>> {
    return axios.post<any>(
        `${baseUrl()}/postSlideShow`,
        params.body,
        {
            headers: {
                'Content-Type': 'application/json'
            }
        }
    ).then(res => { return { data: res.data, errorStatus: undefined, errorMessage: undefined } })
        .catch((e) => handleApiErrors<any>(e));
}

export async function getSlideshowInfo(imgName: string): Promise<ApiResponse<any>> {
    return axios.get<any>(`${baseUrl()}/listofslideshow/${imgName}`)
        .then(res => { return { data: res.data, errorStatus: undefined, errorMessage: undefined } })
        .catch((e) => handleApiErrors<any>(e));
}

export async function getActiveInfo(imgName: string): Promise<ApiResponse<any>> {
    return axios.get<any>(`${baseUrl()}/listofactive/${imgName}`)
        .then(res => { return { data: res.data, errorStatus: undefined, errorMessage: undefined } })
        .catch((e) => handleApiErrors<any>(e));
}